import BaseModel from "../base_model.js.jsx";

class RawProjectBonusRateModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "deadline",
        displayName: this.fieldDisplayName("deadline"),
        type: "dateTime",
        format: "DD.MM.YYYY",
        weight: 6,
        // type: "date",
        required: true,
      },
      {
        name: "rate",
        displayName: this.fieldDisplayName("rate"),
        type: "decimal",
        weight: 6,
        precision: 5,
        scale: 2,
        required: true,
      },
    ]
  }

  i18nScope() {
    return "model.projects.bonus_rate";
  }

}
const ProjectBonusRateModel = new RawProjectBonusRateModel();

export { RawProjectBonusRateModel, ProjectBonusRateModel }
